<template>
    <q-modal v-model="show_report" :content-css="{ minWidth: '100vw', minHeight: '100vh' }" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
                <q-toolbar-title> {{ id }} - {{ title }} </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <q-tabs v-model="tab" color="secondary" class="shadow-1">
                    <q-tab slot="title" name="certificates" icon="fal fa-file-certificate" :label="$t('certificates')" />
                    <q-tab slot="title" name="tests" icon="fal fa-list-alt" :label="$t('tests')" />
                    <q-tab slot="title" name="games" icon="fal fa-gamepad" :label="$t('games')" />
                    <q-tab slot="title" name="modules" icon="fal fa-users-class" :label="$t('modules')" />
                    <q-tab slot="title" name="registrations" icon="fal fa-ballot-check" :label="$t('registrations')" class="text-bold" />
                    <q-tab slot="title" name="availables" icon="fal fa-users" :label="$t('availables')" class="text-bold" />
                    <q-tab slot="title" name="support_material" icon="fal fa-download" :label="$t('support_material')" />
                    <q-tab slot="title" name="reaction_tests" icon="fal fa-clipboard-list-check" :label="$t('reaction_tests')" />
                    <q-tab slot="title" name="stars" icon="fal fa-star" :label="$t('comments')" />
                    <q-tab slot="title" name="likes" icon="fal fa-thumbs-up" :label="$t('likes')" />
                    <q-tab slot="title" name="favorites" icon="fal fa-heart" :label="$t('favorites')" />

                    <q-tab-pane name="certificates" class="q-px-lg q-pb-xl" keep-alive>
                        <certificates :load="tab === 'certificates' && show_report_training ? true : false" :status="status" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="tests" class="q-px-lg q-pb-xl" keep-alive>
                        <tests :load="tab === 'tests' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="games" class="q-px-lg q-pb-xl" keep-alive>
                        <games :load="tab === 'games' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="modules" class="q-px-lg q-pb-xl" keep-alive>
                        <modules :load="tab === 'modules' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="registrations" class="q-px-lg q-pb-xl" keep-alive>
                        <registrations :load="tab === 'registrations' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="availables" class="q-px-lg q-pb-xl" keep-alive>
                        <availables :load="tab === 'availables' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="support_material" class="q-px-lg q-pb-xl" keep-alive>
                        <support-material :load="tab === 'support_material' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="reaction_tests" class="q-px-lg q-pb-xl" keep-alive>
                        <reaction-test :load="tab === 'reaction_tests' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="stars" class="q-px-lg q-pb-xl" keep-alive>
                        <comments :load="tab === 'stars' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="likes" class="q-px-lg q-pb-xl" keep-alive>
                        <likes :load="tab === 'likes' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="favorites" class="q-px-lg q-pb-xl" keep-alive>
                        <favorites :load="tab === 'favorites' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>
                </q-tabs>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import Certificates from 'components/admin/trainings/report/Certificates'
import Tests from 'components/admin/trainings/report/Tests'
import Games from 'components/admin/trainings/report/Games'
import Modules from 'components/admin/trainings/report/Modules'
import Registrations from 'components/admin/trainings/report/Registrations'
import Availables from 'components/admin/trainings/report/Availables'
import Comments from 'components/admin/trainings/report/Comments'
import Favorites from 'components/admin/trainings/report/Favorites'
import Likes from 'components/admin/trainings/report/Likes'
import ReactionTest from 'components/admin/trainings/report/ReactionTest'
import SupportMaterial from 'components/admin/trainings/report/SupportMaterial'

export default {
    props: ['show_report_training', 'id', 'status', 'title'],

    components: {
        certificates: Certificates,
        tests: Tests,
        games: Games,
        modules: Modules,
        registrations: Registrations,
        availables: Availables,
        comments: Comments,
        favorites: Favorites,
        'reaction-test': ReactionTest,
        likes: Likes,
        'support-material': SupportMaterial
    },

    data() {
        return {
            tab: 'certificates'
        }
    },

    computed: {
        show_report: {
            get() {
                return this.show_report_training
            },
            set() {
                this.$emit('hide_report', '')
                this.tab = 'certificates'
            }
        }
    }
}
</script>

<style></style>
